<template>
    <main class="main">
        <v-container no-padding-y>
            <v-layout>
                <v-flex>
                    <v-breadcrumbs :items="breadcrumbs">
                        <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
        </v-container>

        <div class="single_section--holder">
            <v-container>
                <v-layout column>
                    <v-flex>
                        <section class="single_section v-card v-card--flat v-sheet v-sheet--tile theme--light">
                            <h1 class="v-card__title">
                                <v-list-item-avatar color="#b9b9b9" size="32" class="mr-4">
                                    <span class="white--text headline font-weight-bold">Q</span>
                                </v-list-item-avatar>
                                <span class="v-list-item__content">{{ question.title }}</span>
                            </h1>

                            <section class="answer_section v-card v-card--flat v-sheet v-sheet--tile theme--light">
                                <h2 class="v-card__title mb-1">
                                    <v-avatar color="#36cefc" size="32">
                                        <span class="white--text headline font-weight-bold">A</span>
                                    </v-avatar>
                                </h2>

                                <div class="answer_section--content" v-html="question.answer" />
                            </section>
                        </section>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <div class="accordion_section">
            <v-container>
                <v-layout column>
                    <v-flex>
                        <section class="related_questions v-card v-card--flat v-sheet v-sheet--tile theme--light">
                            <h2 class="v-card__title">この記事に関連する質問</h2>
                            <questions-category-list
                                :category-id="question.category_id"
                                :subcategory-id="question.subcategory_id"
                            />
                        </section>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
    </main>
</template>

<script>
import QuestionsCategoryList from '~/components/atoms/QuestionsCategoryList'
export default {
    name: 'FaqId',
    components: { QuestionsCategoryList },
    layout: 'questions',
    head () {
        return {
            title: `${this.question.title} - クラウドファンディングのMotionGallery`
        }
    },
    data: () => ({
    }),
    computed: {
        question () {
            return this.$store.getters.getQuestionById(parseInt(this.$route.params.id))
        },

        breadcrumbs () {
            return [
                {
                    text: 'HOME',
                    nuxt: true,
                    disabled: false,
                    href: 'https://motion-gallery.net/'
                },
                {
                    text: 'よくあるご質問',
                    nuxt: true,
                    disabled: false,
                    to: '/'
                },
                {
                    text: this.question.title,
                    disabled: true
                }
            ]
        }
    }
}
</script>
